module.exports = __webpack_public_path__ + "img/background-change-password@2x.647b4681.jpg";